<div
  (swipeleft)="onSwipeLeft($event)"
  (swipeRight)="onSwipeRight($event)"
  id="sliderHome"
  [style.width]="windowsWidth * listArray?.length + 'px'"
  [style.margin-left]="positionPX + 'px'"
  [style.height]="'120px'"
  *ngIf="listArray?.length > 0">
  <div class="owl-item active" class="sliderItem" *ngFor="let i of listArray; let _k = index">
    <div class="item" [style.width]="windowsWidth / countRow + 'px'">
      <div class="heute-main">
        <div class="heute-head">
          <span>
            <ng-container *ngIf="!isLive">
              <image-loader-utils url="clock" extraClasses="clock-icon"></image-loader-utils>
              {{ i.MatchTime }}, {{ i.MatchDate | dateFormatDistance }}</ng-container
            >
            <ng-container *ngIf="isLive">{{ 'home_live' | t }} </ng-container>
            <ng-container *ngIf="isLive">{{ i.MatchTime }}{{ i.TimeStatu == '3' ? ' - ' + i.TimeStatuColor : null }}</ng-container>
          </span>
        </div>
        <div class="body-huete" (click)="isLive ? goLiveEventDetail(i.EventId) : goEventDetail(i.MatchId)">
          <div class="itemLine">
            <h2>{{ i.HomeTeam }}</h2>
            <span class="score">{{ isLive ? i.Score.split(':')[0] : null }}</span>
          </div>
          <small>VS</small>
          <div class="itemLine">
            <h2>{{ i.AwayTeam }}</h2>
            <span class="score">{{ isLive ? i.Score.split(':')[1] : null }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
